module.exports = __webpack_public_path__ + "media/censor-beep-2.421c138a.mp3";